import React, { useState } from 'react';
import { Box, TextField, Button, Alert, Typography } from '@mui/material';
import { resetPassword } from '../../hooks/security/password';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^[0-9]{9,15}$/;

function RecordarPassword() {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setSuccess(false);

    if (!emailRegex.test(email) || !phoneRegex.test(phone)) {
      setError('Datos no válidos');
      return;
    }

    try {
      setLoading(true);
      await resetPassword(email.trim(), phone.trim());
      setSuccess(true);
    } catch {
      setError('No se pudo procesar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Box sx={{ width: 500, p: 4, bgcolor: '#333', borderRadius: 1 }}>
        <Typography variant="h5" sx={{ color: 'white', mb: 2 }}>
          Recordar Password
        </Typography>

        {error && <Alert severity="error">{error}</Alert>}
        {success && (
          <Alert severity="success">
            Si la cuenta existe, recibirás un correo
          </Alert>
        )}

        <TextField
          label="Teléfono"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          fullWidth
          margin="normal"
          sx={{ backgroundColor: 'white', borderRadius: 1 }}
        />

        <TextField
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          margin="normal"
          sx={{ backgroundColor: 'white', borderRadius: 1 }}
        />

        <Button
          fullWidth
          variant="contained"
          color="error"
          disabled={loading}
          onClick={handleSubmit}
          sx={{ marginTop: "15px" }}
        >
          {loading ? 'Procesando...' : 'Recordar Password'}
        </Button>
      </Box>
    </Box>
  );
}

export default RecordarPassword;
